import { Organisme } from './organisme';
import { Patient } from './patient';
import { Prescription } from './prescription';
import { PrescriptionForm } from './prescriptionForm/prescriptionForm';
import { User } from './user';

export class PrescriptionFormDialogData {
  patient: Patient | undefined;
  prescription: Prescription | undefined;
  codeDActivite: string;
  prescriptionFormPrecedente: PrescriptionForm | undefined;
  userList: User[];
  organisme: Organisme | null;
  reedition: boolean;

  constructor(
    patient: Patient | undefined,
    dateDebut: Prescription | undefined,
    codeDActivite: string,
    prescriptionActuelle: PrescriptionForm | undefined,
    userList: User[],
    organisme: Organisme | null,
    reedition: boolean = false,
  ) {
    this.patient = patient;
    this.prescription = dateDebut;
    this.codeDActivite = codeDActivite;
    this.prescriptionFormPrecedente = prescriptionActuelle;
    this.userList = userList;
    this.organisme = organisme;
    this.reedition = reedition;
  }
}
